// extracted by mini-css-extract-plugin
export default {"tabs":"lhlQy","tab":"sRG78","description":"BdMv2","form":"rQbWK","preloader":"oLh44","delivery-form--centered":"q0JF6"};